<template>
    <div class="" style="padding-bottom: 1px">
        <div class="textCenter">
            <img :src="adList.length > 0 ? adList[0]['adPicturePath'] : ''" alt="" class="wContent" style="margin-top: 10px">
        </div>
        <div class="mw-modular-box wContent center bgWhite" style="box-sizing: border-box; padding: 60px 80px;">
            <el-row>
                <el-col :span="5">
                    <div class="grid-content">
                        <ul class="menu-list">
                            <li><a href="javascript:;" class="block w100 textCenter font14" :class="{'active': tab == 1}" @click="changeTab(1)">品种介绍</a></li>
                            <li><a href="javascript:;" class="block w100 textCenter font14" :class="{'active': tab == 2}" @click="changeTab(2)">交易规则</a></li>
                            <li><a href="javascript:;" class="block w100 textCenter font14" :class="{'active': tab == 3}" @click="changeTab(3)">指定交收仓库</a></li>
                            <li><a href="javascript:;" class="block w100 textCenter font14" :class="{'active': tab == 4}" @click="changeTab(4)">交易指南</a></li>
                        </ul>
                    </div>
                </el-col>
                <el-col :span="19">
                    <div class="grid-content">
                        <div class="menu-content p20 font16 fontDark" v-show="tab == 1">
                            钢坯是炼钢炉炼成的钢水经过铸造后得到的产品。<br>
                            从外形上主要分为两种：<br>
                            板坯：截面宽、高的比值较大，主要用来轧制板材。<br>
                            方坯：截面宽、高相等，或差别不大，主要用来轧制型钢、线材。<br>
                            钢坯是指用于生产钢材的半成品，一般不能直接供社会使用。 钢坯与钢材是有严格划分标准的，不能以是不是企业最终产品来确定，而要按全社会统一的标准来执行。通常情况下，钢坯与钢材是比较容易区分的，但对于某些钢坯，与钢材具有同样规格和同样用途的（如轧制管坯），可通过是否供其他行业使用、是否经过钢材加工工艺过程、是否经过成品轧机加工来区分。
                        </div>
                        <div class="menu-content p20 font20 fontDark" v-show="tab == 2">
                            <h1 class="textCenter">日照大宗商品交易中心钢坯调期交易规则</h1>
                            <small class="block textCenter mw-modular-box">发布时间：2019-07-26&nbsp;&nbsp;&nbsp;&nbsp;来源：日照大宗商品交易中心</small>
                            <div class="line"></div>
                            <h1 class="textCenter mw-modular-box">第一章 总则</h1>
                            <p><strong>第一条</strong> 为规范日照大宗商品交易中心（以下简称“日照大商中心”）钢坯调期交易行为，维护市场参与各方的权利与义务，特制定本规则。</p>
                            <p><strong>第二条</strong> 钢坯调期交易参与者、钢坯指定交收仓库、指定交收厂库、指定结算机构、指定检验机构、特许服务商及其相关人员、日照大商中心工作人员等与钢坯调期交易相关的各方主体必须遵守本规则。</p>
                            <p>日照大商中心与调期交易参与者、钢坯指定交收仓库、指定交收厂库、指定结算机构、指定检验机构、特许服务商等主体之间的权利义务关系，在日照大商中心与各方的协议中具体约定。</p>

                            <h1 class="textCenter mw-modular-box">第二章 交易术语</h1>
                            <p><strong>第三条</strong> “订立”是指市场参与者通过电子交易系统，与交易对方签订远期电子合同的交易行为。</p>
                            <p><strong>第四条</strong> “转让”是指合同持有者将签订的电子合同转让给其他市场参与者的交易行为。转让双方电子合同到期时间不一致时，由特许服务商进行调期结算。</p>
                            <p><strong>第五条</strong> “交收”是指市场参与者根据电子合同约定，办理标的商品所有权转移手续的过程。</p>
                            <p><strong>第六条</strong> “调期交收”是指市场参与者将未到期的电子合同，向特许服务商申请提前交收，在到期日之前卖出或者获得现货实物的过程。</p>
                            <p><strong>第七条</strong> “协议交收”是指市场参与者协商一致，达成现货购销意向，向日照大商中心申请，提前履行合同的过程。</p>
                            <p><strong>第八条</strong> 电子合同”是指市场参与者通过日照大商中心的电子交易系统签订的约定双方权利和义务的电子协议。</p>
                            <p><strong>第九条</strong> “订金”是指参与者通过日照大商中心电子交易系统签订电子合同，按日照大商中心规定的额度和进度支付的一定数额的资金，作为向交易对方履约的保证。</p>
                            <p><strong>第十条</strong> “调期服务费”是指特许服务商为客户提供调期结算服务收取的费用。</p>
                            <p><strong>第十一条</strong> “特许服务商”是指经日照大商中心核准，为市场参与者的调期转让、调期交收、协议交收提供服务的法人机构。</p>
                            <p><strong>第十二条</strong> “现货升贴水报价”是指特许服务商每个交易日公布的现货升贴水报价，客户可根据该报价，向特许服务商提报调期交收意向价格。</p>
                            <p><strong>第十三条</strong> “结算价”是日照大商中心根据交易结果和中心有关规定对市场参与者订金、订货盈亏、交收货款和其他有关款项进行计算划拨的基准价格。</p>
                            <p><strong>第十四条</strong> “电子仓单”是指在日照大商中心电子交易系统中，市场参与者用于交收等相关业务的商品存货凭证，按照方式不同，可分为仓库电子仓单和厂库电子仓单。</p>

                            <h1 class="textCenter mw-modular-box">第三章 电子合同主要条款</h1>
                            <p><strong>第十五条</strong> 钢坯调期交易的交易标的为钢号Q235B的钢坯。电子合同主要条款如下表所示：</p>
                            <table class="center textCenter font16" style="width: 80%">
                                <tr>
                                    <td>商品名称</td>
                                    <td>钢坯</td>
                                </tr>
                                <tr>
                                    <td>交易代码</td>
                                    <td>GP-Q235-D28</td>
                                </tr>
                                <tr>
                                    <td>报价单位</td>
                                    <td>元/吨</td>
                                </tr>
                                <tr>
                                    <td>价格最小变动单位</td>
                                    <td>1元/吨</td>
                                </tr>
                                <tr>
                                    <td>到期时间</td>
                                    <td>订立日期起28天（遇法定节假日提前）</td>
                                </tr>
                                <tr>
                                    <td>交收日期</td>
                                    <td>所有交易日</td>
                                </tr>
                                <tr>
                                    <td>交收基准品</td>
                                    <td>Q235</td>
                                </tr>
                            </table>
                            <table class="center textCenter font16 mw-modular-box" style="width: 80%">
                                <tr>
                                    <td>商品名称</td>
                                    <td>钢坯D1</td>
                                </tr>
                                <tr>
                                    <td>交易代码</td>
                                    <td>GP-Q235-D1</td>
                                </tr>
                                <tr>
                                    <td>报价单位</td>
                                    <td>元/吨</td>
                                </tr>
                                <tr>
                                    <td>价格最小变动单位</td>
                                    <td>1元/吨</td>
                                </tr>
                                <tr>
                                    <td>到期时间</td>
                                    <td>合同订立当日到期</td>
                                </tr>
                                <tr>
                                    <td>交收日期</td>
                                    <td>所有交易日</td>
                                </tr>
                                <tr>
                                    <td>交收基准品</td>
                                    <td>Q235</td>
                                </tr>
                            </table>

                            <h1 class="textCenter mw-modular-box">第四章 交易资格</h1>
                            <p><strong>第十六条</strong> 市场参与主体签署入市协议，办理开户手续、获得交易账户后，方可通过交易系统参与钢坯调期交易。有关市场参与主体的交易资格终止、账户注销等，应遵守日照大商中心有关管理办法的规定。</p>
                            <p><strong>第十七条</strong> 钢坯调期交易存在一定的价格波动风险，为保护市场参与主体利益，客户必须符合《日照大宗商品交易中心市场参与主体适当性管理办法》的要求，具备一定的风险承受能力。自然人客户不允许参与GP-235Q-D1的交易。</p>
                            <p><strong>第十八条</strong> 钢坯调期交易实行实物交收，参与钢坯商品卖交收的客户，应具备开具增值税专用发票的资格。</p>

                            <h1 class="textCenter mw-modular-box">第五章 交易</h1>
                            <p><strong>第十九条</strong> 钢坯调期交易的交易时间为周一到周五9：00-11：30, 13：30-15：30，法定节假日除外。日照大商中心可根据市场参与者的需求和市场情况，适时调整交易时间，具体交易时间以最新的中心公告为准。</p>
                            <p><strong>第二十条</strong> 订立。在账户有足额资金的前提下，市场参与者可通过交易系统的“订立”指令，买入或者卖出商品，签订28天或1天到期的电子合同。订立指令发出后，系统自动冻结相应数量的订金。</p>
                            <p><strong>第二十一条</strong> 转让。市场参与者通过交易系统的“转让”和“调期转让”指令，将合同让渡给其它市场参与方。成交后，系统全额释放冻结的订金，并划转转让盈亏。交易双方电子合同到期时间不一致时，由特许服务商进行调期结算，转让方需向特许服务商另行支付调期服务费。</p>
                            <p><strong>第二十二条</strong> 客户订立或转让电子合同时，需向日照大商中心支付交易服务费。具体收费标准以日照大商中心公告为准。日照大商中心有权根据市场情况对交易服务费收取标准进行调整。</p>

                            <h1 class="textCenter mw-modular-box">第六章 结算</h1>
                            <p><strong>第二十三条</strong> 客户订立合同需支付订金。订金收取比例由日照大商中心制定并可根据市场情况进行调整，具体实施标准以日照大商中心公告为准。</p>
                            <p><strong>第二十四条</strong> 客户调期转让时，系统自动扣减调期服务费。每日结算后，日照大商中心公布下一交易日调期服务费收取标准，客户可通过交易系统查询。</p>
                            <p><strong>第二十五条</strong> 客户注册的电子仓单可按一定比例折抵订金。</p>
                            <p><strong>第二十六条</strong> 盈亏计算公式（不含交易服务费）：</p>
                            <p>转让盈亏=∑[（卖出转让价-买入订立价）*卖出转让量]+∑[（卖出订立价-买入转让价）*买入转让量]；</p>
                            <p>调期转让盈亏=∑[（调期卖出转让价-买入订立价-调期服务费）*调期卖出转让量]+∑[（卖出订立价-调期买入转让价-调期服务费）*调期买入转让量]；</p>
                            <p>订货盈亏=∑[（结算价-买入订立价）*买入持有量]+∑[（卖出订立价-结算价）*卖出持有量]。</p>
                            <p><strong>第二十七条</strong> 客户如对结算数据有异议，须在下一交易日开市前以书面形式提出，否则视为确认日照大商中心的结算结果。</p>

                            <h1 class="textCenter mw-modular-box">第七章 交收</h1>
                            <p><strong>第二十八条</strong> 客户申请交收，买方需缴纳足额货款，卖方需注册足额电子仓单。</p>
                            <p>电子仓单注册办法参见《日照大宗商品交易中心钢坯电子仓单管理办法》。</p>
                            <p>交收品质量标准参见《日照大宗商品交易中心钢坯调期交易交收细则》。</p>
                            <p><strong>第二十九条</strong> 到期交收。28天到期电子合同，自电子合同订立的第22个自然日至电子合同到期日为电子合同交收期，进入交收期后保证金不足20%的需补足。交收期起始日遇国家法定节假日、周六、周日前提至最近一个交易日。交收期内的第1-2个交易日为到期交收预报期，拟进行到期交收的客户需在到期交收预报期最后一日16:00前,按照日照大商中心公布的《到期交收预报表》及联系方式提交到期交收预报。1天到期电子合同，当天交易结束后直接进入交收环节，不进行交收预报。</p>
                            <p>28天到期电子合同的卖方客户或卖方特许服务商应在电子合同到期日前一交易日完成电子仓单注册，买方客户或买方特许服务商应在电子合同到期日前一天补足100%的货款。1天到期电子合同的卖方客户应在成交当日完成电子仓单注册，买方客户应在成交当日补足100%的货款。</p>
                            <p>合同到期后根据电子合同约定，办理标的商品所有权转移、货款划拨手续。</p>
                            <p><strong>第三十条</strong> 调期交收。市场参与者根据特许服务商每日公布的现货升贴水报价，提交意向交收价格和交收数量，申请将未到期的合同进行调期交收。特许服务商响应确认后，办理标的商品所有权转移、货款划拨、电子合同转移手续。</p>
                            <p><strong>第三十一条</strong> 协议交收。合同双方协商一致，达成现货购销合同，向日照大商中心申请，日照大商中心根据协议协商结果，监督其商品交付及货款划转。</p>
                            <p><strong>第三十二条</strong> 不符合交收要求的，必须在电子合同进入交收期之前进行调期转让。不符合交收要求且未按日照大商中心规定进行调期转让的，日照大商中心有权对其电子合同进行强行转让。</p>
                            <p><strong>第三十三条</strong> 货款结算。日照大商中心按照交收结算价划转85%货款至卖方账户；同时，将电子仓单划至买方账户。</p>
                            <p><strong>第三十四条</strong> 发票开具。卖方应在货款划拨后30个工作日内开具增值税专用发票。日照大商中心在买方确认收票后，划拨卖方剩余货款。</p>
                            <p>买卖双方另有约定的，经日照大商中心核准后，按双方约定执行。</p>

                            <h1 class="textCenter mw-modular-box">第八章 风险控制</h1>
                            <p><strong>第三十五条</strong> 钢坯调期交易实行客户订货限额制度，单一客户的订货额度上限以及交收额度上限由日照大商中心根据市场情况进行调整，以日照大商中心公告为准。</p>
                            <p><strong>第三十六条</strong> 钢坯调期交易实行“单笔最大订货量”制度，每个客户单笔最大订货量不超过5000吨。</p>
                            <p><strong>第三十七条</strong> 钢坯调期交易实行单边最大波幅制度，每日单边最大波幅不超过上一交易日该商品结算价的10%。日照大商中心可根据市场风险情况双向或单向调整单边最大波幅，或者采取其它必要的措施，以稳定市场、维护交易秩序。</p>
                            <p><strong>第三十八条</strong> 日照大商中心有权根据市场情况调整订金比例，订金实际调整比例以日照大商中心公告为准。</p>
                            <p><strong>第三十九条</strong> 钢坯调期交易实行强行转让制度。客户未在规定时间内追加订金，或订货量超过限额未在规定时间内作出说明或调整订货数量的，或客户出现违反日照大商中心规则和政策，或市场出现重大风险。日照大商中心有权对客户的订货合同做强行转让处理。</p>
                            <p><strong>第四十条</strong> 日照大商中心实行一致行动人制度。</p>
                            <p>市场参与者具有下列情形之一的，应当认定为一致行动人行为：</p>
                            <p>（一）行为人作为他人的控股股东，即行为人的出资额占他人资本总额50%以上或者其持有的股份占他人股本总额50%以上的股东，出资额或者持有股份的比例虽然不足50%，但依其出资额或者持有的股份所享有的表决权已足以对股东会、股东大会的决议产生重大影响的股东；</p>
                            <p>（二）行为人作为他人的开户授权人、指定下单人、资金调拨人、结算单确认人或者其他形式的委托代理人；</p>
                            <p>（三）行为人作为他人的法定代表人、主要合伙人、董事、监事、高级管理人员等，或者行为人与他人的法定代表人、主要合伙人、董事、监事、高级管理人员等一致的；</p>
                            <p>（四）行为人与他人之间存在配偶关系；</p>
                            <p>（五）行为人与他人之间存在父母、子女、兄弟姐妹等关系，且对他人日照大商中心账户的日常交易决策具有决定权或者重大影响；</p>
                            <p>（六）行为人通过投资关系、协议、融资安排或者其他安排，能够对他人的日照大商中心账户的日常交易决策具有决定权或者重大影响；</p>
                            <p>（七）行为人对两个或者多个他人交易账户的日常交易决策具有决定权或者重大影响；</p>
                            <p>（八）日照大商中心认定的其他情形。</p>
                            <p>日照大商中心对符合一致行动人行为的，将其持有的合同及调期交易量、调期交收量、到期交收量等进行合并计算和管理。</p>
                            <p><strong>第四十一条</strong> 为防范和化解市场风险，日照大商中心对交易进行监控。对干扰市场秩序、恶意操纵市场价格、互相串通采取一致行动等异常交易行为，日照大商中心有权采取提高保证金、限制订立、强制转让等措施。</p>
                            <p><strong>第四十二条</strong> 为防范和控制市场及市场参与者的资金风险，日照大商中心可调整已签订和（或）新订电子合同的订金标准；可根据某一商品或某一交易席位的异常交易情况，单个或集体对市场参与者提高电子合同的订金标准。</p>
                            <p><strong>第四十三条</strong> 为防范和化解市场风险，日照大商中心有权实行包括但不限于以下措施：根据实际情况，对已签订的电子合同采取限时限量自行转让、强制转让或指定价格强制解除、全部合同提前交收、停止或暂停商品的交易等非常措施，以确保电子交易的平稳运行和顺利发展。</p>

                            <h1 class="textCenter mw-modular-box">第九章 违约行为及处理</h1>
                            <p><strong>第四十四条</strong> 客户应对其通过日照大商中心签署的电子合同承担全面履行、诚信履行的义务。</p>
                            <p><strong>第四十五条</strong> 违约是指客户违反电子交易合同或日照大商中心交易办法的约定，不履行、不完全履行或者履行合同义务不符合约定的行为。客户违约情形的认定及处理方式根据日照大商中心交易办法和买卖双方签署的电子合同执行。</p>
                            <p><strong>第四十六条</strong> 对违约或违反日照大商中心有关规定的客户，日照大商中心有权视情节轻重对其进行警告、罚款、暂停交易、限制交易权限、冻结电子仓单、注销客户账户以及日照大商中心认可的其他措施；涉及合同对手方的，日照大商中心有权没收其订金，保障合同对手方权益。违规行为涉嫌犯罪的，日照大商中心可移交司法机关，追究刑事责任等。</p>
                            <p><strong>第四十七条</strong> 客户在交易及交收过程中所产生的纠纷，由日照大商中心按照双方签署的电子合同及日照大商中心交易规则进行协调。</p>
                            <p>日照大商中心对违约情形的认定及对纠纷的协调，是出于化解交易纠纷、维护交易秩序的目的，并不意味着排除仲裁机构、人民法院及其他国家有权机关对事实的认定；客户对日照大商中心的协调有异议时，发生纠纷的客户双方可按合同约定直接向仲裁机构申请仲裁或向人民法院提起诉讼。</p>

                            <h1 class="textCenter mw-modular-box">第十章 信息发布和管理</h1>
                            <p><strong>第四十八条</strong> 日照大商中心通过官方网站www.rzbot.com或交易系统，公布中心文件、公告、当日交易的价格行情及其它统计资料和行情信息。</p>
                            <p><strong>第四十九条</strong> 日照大商中心发布的信息包括：商品名称、商品代码、最新价、单边最大波幅、最高价、最低价、结算价、成交量、订货量，以及生产厂商或品牌、指定交收仓库、指定交收厂库、指定结算机构等需要公布的信息。</p>
                            <p><strong>第五十条</strong> 日照大商中心根据不同内容按实时、每日、每周、每月，定期或不定期发布信息。中心可根据具体情况对每类信息的发布周期进行调整。</p>

                            <h1 class="textCenter mw-modular-box">第十一章 附则</h1>
                            <p><strong>第五十一条</strong> 本规则的解释权属于日照大宗商品交易中心有限公司。日照大商中心有权根据市场参与者的需求和实际情况，对本规则进行修订。</p>
                            <p><strong>第五十二条</strong> 本规则所涉及的各方主体，除遵守本规则的规定外，还应遵守日照大商中心制定的其他管理办法及其与日照大商中心所签订的相关协议。</p>
                            <p><strong>第五十三条</strong> 本规则自发布之日起实施。</p>

                        </div>
                        <div class="menu-content p20 font14" v-show="tab == 3">
                            <table class="w100 textCenter store">
                                <tr>
                                    <td colspan="9" class="thead fontNormal fontBold font16">日照大宗商品交易中心钢坯调期交易指定交收仓库名录</td>
                                </tr>
                                <tr class="tbody fontBold">
                                    <td>序号</td>
                                    <td>交收仓库名称</td>
                                    <td>地址</td>
                                    <td>联系人</td>
                                    <td>联系电话</td>
                                    <td>传真</td>
                                    <td>电子邮箱</td>
                                    <td>基准库/非基准库</td>
                                    <td>与基准库升贴水（元/吨）</td>
                                </tr>
                                <tr class="tbody">
                                    <td>1</td>
                                    <td>唐山象屿正丰国际物流有限公司</td>
                                    <td>河北省唐山市丰润区林荫南路东侧</td>
                                    <td>肖向松</td>
                                    <td>15932082485</td>
                                    <td>0315-3240083</td>
                                    <td>tsxyzf@xiangyu.cn</td>
                                    <td>基准库</td>
                                    <td></td>
                                </tr>
                                <tr class="tbody">
                                    <td>2</td>
                                    <td>唐山海翼宏润物流有限公司</td>
                                    <td>河北省唐山市丰润区丰津公路小张各庄镇</td>
                                    <td>张磊</td>
                                    <td>15031594777</td>
                                    <td>0315-3842444</td>
                                    <td>lei.zhang@ccregroup.com</td>
                                    <td>基准库</td>
                                    <td></td>
                                </tr>
                                <tr class="tbody">
                                    <td>3</td>
                                    <td>浙江物产物流投资有限公司唐山分公司</td>
                                    <td>河北省唐山市丰南区丰南镇小翟庄花园路58号</td>
                                    <td>侯静</td>
                                    <td>18003150835</td>
                                    <td>0315-5530961</td>
                                    <td>zjmizx@163.com</td>
                                    <td>基准库</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="9" style="height: 60px;" class="textLeft vTop">备注：交收仓库每日最低出库量为1000吨</td>
                                </tr>
                            </table>
                        </div>
                        <div class="menu-content p20 font14" v-show="tab == 4">
                            <h3 class="textCenter font20" style="padding: 15px 0;">交易指南</h3>
                            <div>
                                <img src="../../assets/images/service_1.png" alt="" class="w100">
                                <img src="../../assets/images/service_2.jpg" alt="" class="w100">
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import { baseUrl, adIDs } from '../../assets/js/common'
export default {
    name: 'ServiceDetail',
    components: {ConcatsControl},
    data () {
        return {
            tab: 1,
            adList: []
        }
    },
    mounted () {
        // 初始化内容
        this.tab = this.$route.params.type;
        this.getAdByAdp();
    },
    methods: {
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${adIDs['indexRow']}`, {}).then(res => {
                if (res.code == 0) {
                    console.log(res.data)
                    self.adList = res.data;
                }
            })
        },
        changeTab (type) {
            this.tab = type;
        }
    }
}
</script>

<style scoped>
    .menu-list a { height: 45px; line-height: 45px; color: #333; background: #eee; border-bottom: 1px solid #fff; }
    .menu-list a:hover,.menu-list a.active { background: #a30000; color: #fff; }
    .menu-content { border: 1px solid #999; color: #333; line-height: 28px; box-sizing: border-box; margin-top: 1px; min-height: 500px; }
    .menu-content table { border-collapse:collapse; }
    .menu-content .store .thead { height: 40px; line-height: 40px; }
    .menu-content .store .tbody td { padding: 3px 5px; line-height: 20px; }
    .menu-content .store .tbody td:first-child { width: 40px; }
    .menu-content .store .tbody td:nth-child(2), .menu-content table .tbody td:nth-child(3) { width: 90px; }
    .menu-content .store .tbody td:nth-child(4) { width: 60px; }
    .menu-content .store .tbody td:nth-child(4) { width: 50px; }
    .menu-content .store .tbody td:first-child { width: 40px; }
    .menu-content table td { border: 1px solid #333; }
    .line { border-bottom: 1px dotted #ccc; }
    .menu-content h1 { font-size: 20px; }
    .menu-content p { text-indent: 2rem; line-height: 40px; }
</style>